<template>
    <div class="InstagramBusinessChannelStatistics bg-white">
        <hr style="
            border-top: 3px solid var(--magic-color);
            margin-bottom: 40px;
            margin-top: 20px;
        " />

        <section v-if="channelStat" class="mb-12">
            <div class="">
                <h3 class="font-bold uppercase">Målgruppe</h3>
                <span class="small block" style="color: var(--magic-color);">
                    Senest opdateret: {{ channelStat.created_at | past | relative }}
                </span>
            </div>

            <ResponsiveGrid :columns="{ default: 1, md: 2 }" gap="20px" class="mb-6">
                <InstagramBusinessChannelGeographics :channel-stat="channelStat" />
                <InstagramBusinessChannelDemographics :channel-stat="channelStat" />
            </ResponsiveGrid>

            <InstagramBusinessChannelFollowerActivity :channel-stat="channelStat" />
        </section>

        <section v-if="latestContent">
            <div class="">
                <h3 class="font-bold uppercase">Indhold</h3>
                <span class="small block" style="color: var(--magic-color);">
                    Senest opdateret: {{ latestContent.created_at | past | relative }}
                </span>
            </div>

            <InstagramBusinessContentMediaFeed
                v-if="channelMedias.length > 0"
                class="mb-6"
                :channel="channel"
                :contents="channelMedias"
            />

            <InstagramBusinessContentStoryFeed
                v-if="channelStories.length > 0"
                :channel="channel"
                :contents="channelStories"
            />
        </section>
    </div>
</template>

<style type="text/less" lang="less">
.InstagramBusinessChannelStatistics h3 {
    @apply text-base font-medium not-italic;
}
</style>

<script>
import InstagramBusinessChannelDemographics from 'dashboard-js/components/influencers/InstagramBusinessChannelDemographics'
import InstagramBusinessChannelFollowerActivity from 'dashboard-js/components/influencers/InstagramBusinessChannelFollowerActivity'
import InstagramBusinessChannelGeographics from 'dashboard-js/components/influencers/InstagramBusinessChannelGeographics'
import InstagramBusinessContentMediaFeed from 'dashboard-js/components/influencers/InstagramBusinessContentMediaFeed'
import InstagramBusinessContentStoryFeed from 'dashboard-js/components/influencers/InstagramBusinessContentStoryFeed'
import ResponsiveGrid from 'dashboard-js/components/ResponsiveGrid'
import collect from 'collect.js'

export default {
    components: {
        InstagramBusinessContentMediaFeed,
        InstagramBusinessContentStoryFeed,
        InstagramBusinessChannelFollowerActivity,
        InstagramBusinessChannelDemographics,
        InstagramBusinessChannelGeographics,
        ResponsiveGrid,
    },

    props: ['channel', 'contents'],

    computed: {
        channelStat() {
            return this.channel.latest_stat
        },

        channelMedias() {
            return collect(this.contents).reject(this.isStory).items
        },

        channelStories() {
            return collect(this.contents).filter(this.isStory).items
        },

        latestContent() {
            return collect(this.contents)
                .sortByDesc(content => content.latest_stat.created_at)
                .first()
        },
    },

    methods: {
        isStory(content) {
            return content.content_type.endsWith('STORY')
        },
    },
}
</script>
